import {
  CopyFormMutation,
  CopyFormMutationVariables,
  CreateFormMutation,
  CreateFormMutationVariables,
  DestroyFormMutation,
  DestroyFormMutationVariables,
  GetFormQuery,
  GetFormQueryVariables,
  UpdateFormThemeMutation,
  UpdateFormThemeMutationVariables,
  UpdateUserFormAppSettingMutation,
  UpdateUserFormAppSettingMutationVariables,
  type GetFormStatsQuery,
  type GetFormStatsQueryVariables,
} from '@/typings/domain'
import apolloClient from './apolloClient'
import CopyFormGQL from './graphql/CopyForm.graphql'
import CreateFormGQL from './graphql/CreateForm.graphql'
import DestroyFormGQL from './graphql/DestroyForm.graphql'
import GetFormGQL from './graphql/GetForm.graphql'
import GetFormStatsGQL from './graphql/GetFormStats.graphql'
import UpdateFormThemeGQL from './graphql/UpdateFormTheme.graphql'
import UpdateUserFormAppSettingGQL from './graphql/UpdateUserFormAppSetting.graphql'

export function createForm(input: CreateFormMutationVariables['input']) {
  return apolloClient.mutate<CreateFormMutation, CreateFormMutationVariables>({
    mutation: CreateFormGQL,
    variables: { input },
    fetchPolicy: 'no-cache',
  })
}

export function getForm({ formToken }: { formToken: string }) {
  return apolloClient.query<GetFormQuery, GetFormQueryVariables>({
    query: GetFormGQL,
    variables: { formToken },
    fetchPolicy: 'no-cache',

  })
}

export function destroyForm({ formToken }: { formToken: string }) {
  return apolloClient.mutate<DestroyFormMutation, DestroyFormMutationVariables>({
    mutation: DestroyFormGQL,
    variables: { input: { id: formToken } },
    fetchPolicy: 'no-cache',
  })
}

export function copyForm({ formToken }: { formToken: string }) {
  return apolloClient.mutate<CopyFormMutation, CopyFormMutationVariables>({
    mutation: CopyFormGQL,
    variables: { input: { id: formToken } },
    fetchPolicy: 'no-cache',
  })
}

export function getFormStats(variables: GetFormStatsQueryVariables) {
  return apolloClient.query<GetFormStatsQuery, GetFormStatsQueryVariables>({
    query: GetFormStatsGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}

export function updateUserFormAppSetting(variables: UpdateUserFormAppSettingMutationVariables) {
  return apolloClient.mutate<UpdateUserFormAppSettingMutation, UpdateUserFormAppSettingMutationVariables>({
    mutation: UpdateUserFormAppSettingGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}

export function updateFormTheme(input: UpdateFormThemeMutationVariables['input']) {
  return apolloClient.mutate<UpdateFormThemeMutation, UpdateFormThemeMutationVariables>({
    mutation: UpdateFormThemeGQL,
    variables: { input },
    fetchPolicy: 'no-cache',
  })
}
